/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ButtonMenuIcon from 'DesignSystem/ButtonMenuIcon/index'
import DollarIcon from 'DesignSystem/Svgs/DollarIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Menu/Content/ProceduresAction/Content",
  isSelected
  
}) {
let tabSelectedTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.tab',
})
let constantData = 'procedures'
let aggregateData = fromAggregate.equals(tabSelectedTabValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected
  
})
  return (<React.Fragment
>
<ButtonMenuIcon
  viewPath={`${viewPath}/ButtonMenuIcon`}
 marginRight={0}
 text="Procedures"
 onClick={onClick}
 data="tab.selected.tab"
 data="'procedures'"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData}
>
{childProps => (
<DollarIcon
{...childProps}
  viewPath={`${viewPath}/DollarIcon`}
 width={16}
 height={16}
 stroke={childProps.isSelected ? "rgb(0,150,89)" : "#474747"}
/>
)}
</ButtonMenuIcon>
{children}
</React.Fragment>)
}